// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nt_1 {
    font-size: 18px;
    background-color: rgb(255, 255, 255);
    color: rgb(0, 0, 0);
}

.nt_div_1 {
    margin: auto;
    width: 50%;
    border: 3px solid #00C6AE;
    padding: 10px;
}

.four-not-four-page {
    margin: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100vh;
    background: #ddd;
}

.four-not-four-page .wrapper {
    max-width: 960px;
    width: 100%;
    margin: 30px auto;
    transform: scale(0.8);
}

.four-not-four-page .landing-page {
    max-width: 960px;
    min-height: 80vh;
    margin: 0;
    box-shadow: 0px 0px 8px 1px #ccc;
    background: #fafafa;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.four-not-four-page h1 {
    font-size: 2em;
    margin: 0;
}

.four-not-four-page p {
    font-size: 1em;
    margin: 16px auto 24px;
    text-align: center;
}

.four-not-four-page button {
    border-radius: 50px;
    padding: 8px 24px;
    font-size: 16px;
    cursor: pointer;
    background: #62AD9B;
    color: #fff;
    border: none;
    box-shadow: 0 4px 8px 0 #ccc;
    max-width: 250px;
}

.four-not-four-page img.tilli {
    max-width: 200px;
}
.four-not-four-page img.teqbahn {
    min-width: 200px;
    max-width: 25%;
}
.four-not-four-page .content {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/error.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,gCAAgC;IAChC,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B","sourcesContent":[".nt_1 {\n    font-size: 18px;\n    background-color: rgb(255, 255, 255);\n    color: rgb(0, 0, 0);\n}\n\n.nt_div_1 {\n    margin: auto;\n    width: 50%;\n    border: 3px solid #00C6AE;\n    padding: 10px;\n}\n\n.four-not-four-page {\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    height: 100vh;\n    background: #ddd;\n}\n\n.four-not-four-page .wrapper {\n    max-width: 960px;\n    width: 100%;\n    margin: 30px auto;\n    transform: scale(0.8);\n}\n\n.four-not-four-page .landing-page {\n    max-width: 960px;\n    min-height: 80vh;\n    margin: 0;\n    box-shadow: 0px 0px 8px 1px #ccc;\n    background: #fafafa;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.four-not-four-page h1 {\n    font-size: 2em;\n    margin: 0;\n}\n\n.four-not-four-page p {\n    font-size: 1em;\n    margin: 16px auto 24px;\n    text-align: center;\n}\n\n.four-not-four-page button {\n    border-radius: 50px;\n    padding: 8px 24px;\n    font-size: 16px;\n    cursor: pointer;\n    background: #62AD9B;\n    color: #fff;\n    border: none;\n    box-shadow: 0 4px 8px 0 #ccc;\n    max-width: 250px;\n}\n\n.four-not-four-page img.tilli {\n    max-width: 200px;\n}\n.four-not-four-page img.teqbahn {\n    min-width: 200px;\n    max-width: 25%;\n}\n.four-not-four-page .content {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
